<template>
  <div id="copilot">
    <div class="icon-copilot" @click="openModal()">
      <img src="@/assets/icones/copilot.svg" alt="" width="25px" />
    </div>
    <b-modal
      id="modal-copilot"
      ref="modalCopilot"
      title="Suporte"
      v-model="enabled"
      centered
      hide-footer
      size="lg"
      scrollable
    >
      <template #modal-title>
        <div class="copilot-header" :style="{ fontSize: baseFontSize + 'px' }">
          <!-- <span>Suporte</span> -->
          <span title="Curtir"><i class="icofont-like"></i></span>
          <span class="deslike" title="Não curtir"
            ><i class="icofont-like"></i
          ></span>
          <span @click="generatePdf()" title="Gerar PDF"
            ><i class="icofont-print"></i
          ></span>
          <span @click="aumentarFonte()" title="Aumentar fonte">A+</span>
          <span @click="diminuirFonte()" title="Diminuir fonte">A-</span>
        </div>
      </template>
      <div class="copilot-messages" ref="modalCopilotMessages">
        <p class="mb-0" :style="{ fontSize: baseFontSize + 'px' }">
          Olá!
          <br />
          <br />
          Ao analisar <strong>{{ item.no_cidadao }}</strong
          >, observa-se que:
        </p>
        <br />
        <div
          v-for="(item, index) in messages"
          :key="index"
          class="copilot-messages-item"
        >
          <div class="icon">
            <img src="@/assets/icones/copilot.svg" alt="" width="25px" />
          </div>
          <div class="text">
            <h4 v-html="item.title"></h4>
            <div class="loading-copilot" v-if="item.loading">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <!-- <div v-else v-html="item.text"></div> -->
            <vue-typed-js
              v-else
              :strings="item.text"
              :contentType="'html'"
              :typeSpeed="5"
              :showCursor="false"
              @onComplete="sendDataOpenAI()"
            >
              <div
                class="typing"
                :style="{ fontSize: baseFontSize + 'px !important' }"
              ></div>
            </vue-typed-js>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { marked } from 'marked'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'Copilot',
  props: {
    item: {
      type: [Object, Boolean],
      default: false,
    },
    rules: {
      type: [Array, Boolean],
      default: false,
    },
  },
  data() {
    return {
      enabled: false,
      text: '',
      loading: false,
      messages: [],
      index: 0,
      baseFontSize: 14,
    }
  },
  watch: {
    item: {
      handler(newValue, oldValue) {
        // console.log(newValue)
      },
      deep: true,
    },
  },
  methods: {
    openModal() {
      this.enabled = true
      this.messages = []
      this.index = 0
      this.sendDataOpenAI()
      this.$emit('openModal', this.enabled)
    },

    async sendDataOpenAI() {
      try {
        const element = this.$props.rules[this.index]

        if (element == undefined) {
          return
        }

        let payload = ''

        payload =
          'Resumir o texto delimitado por tripla crase, considerando a língua portuguesa do Brasil, conforme a norma culta, observando a correta ortografia, gramática e escrita com impessoalidade. Também garantir que o o resumo seja coerente, coeso, objetivo, cordial, motivador e gentil. As siglas encontradas no texto não devem ser escritas por extenso. Trocar os valores null por não tem. Exibir sempre as datas no formato dd/mm/aaaa. Os links não deve ser alterados e devem ser abertos em nova aba. Texto: ```' +
          element.text +
          ' ```'

        let message = {
          author: 'copilot',
          title: element.title,
          text: [],
          loading: true,
        }

        this.messages.push(message)

        const response = await axios.post(
          'https://api.openai.com/v1/chat/completions',
          {
            model: 'gpt-3.5-turbo',
            messages: [{ role: 'user', content: payload }],
            temperature: 0.7,
          },
          {
            headers: {
              Authorization:
                'Bearer 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',
            },
          }
        )
        if (response) {
          let splitMessage = response.data.choices[0].message.content.split(' ')
          this.messages[this.index].text[0] = marked(splitMessage.join(' '), {
            sanitize: true,
          })
          if (element.textOptional !== undefined) {
            this.messages[this.index].text[0] += element.textOptional
          }
          this.messages[this.index].loading = false
        } else {
          this.messages[this.index].text = [
            'Erro ao gerar resposta. Por favor, tente novamente mais tarde.',
          ]
          this.messages[this.index].loading = false
        }
        this.index++
        this.$nextTick(() => {
          const modalBody = document.querySelector('.modal-body')
          modalBody.scrollTop = modalBody.scrollHeight + 100
        })
      } catch (error) {
        console.log(error)
        this.messages[this.index].text = [
          'Erro ao gerar resposta. Por favor, tente novamente mais tarde.',
        ]
        this.messages[this.index].loading = false
        this.index++
      }
    },

    decodeHtml(html) {
      let txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },

    generatePdf() {
      let lMargin = 15 //left margin in mm
      let rMargin = 15 //right margin in mm
      let pdfInMM = 210 // width of A4 in mm
      let pageCenter = pdfInMM / 2
      let widthPage = pdfInMM - lMargin - rMargin

      let doc = new jsPDF('p', 'mm', 'a4')
      doc.setFontSize(12)
      let verticalPosition = 10
      const pageHeight = doc.internal.pageSize.height

      doc.setFont('arial', 'normal')
      doc.text('Olá!', 15, verticalPosition, null, null, 'left')
      verticalPosition += 10

      let text = this.decodeHtml(
        'Ao analisar ' + this.$props.item.no_cidadao + ', observa-se que:'
      )
      text = text.replace(/<[^>]*>/g, '')
      let splitText = doc.splitTextToSize(text, widthPage)
      splitText.forEach((line, idx) => {
        doc.text(line, 15, verticalPosition, {
          maxWidth: widthPage,
          align: 'justify',
        })
        verticalPosition += 7 // Aumenta vertical para a próxima linha
      })

      verticalPosition += 5

      for (let index = 0; index < this.messages.length; index++) {
        const element = this.messages[index]

        // Incrementa a posição vertical para o título
        doc.setFont('arial', 'bold')
        doc.text(element.title, 15, verticalPosition, null, null, 'left')

        doc.setFont('arial', 'normal')
        // Decodifica entidades HTML no texto e remove tags HTML
        let text = this.decodeHtml(element.text[0])
        text = text.replace(/<[^>]*>/g, '')
        verticalPosition += 10 // Espaço antes do texto
        let splitText = doc.splitTextToSize(text, widthPage)
        splitText.forEach((line, idx) => {
          // Verifica se a linha atual cabe na página
          if (verticalPosition >= pageHeight - 10) {
            doc.addPage()
            verticalPosition = 10 // Reset posição vertical para o topo da nova página
          }
          doc.text(line, 15, verticalPosition, {
            maxWidth: widthPage,
            align: 'justify',
          })
          verticalPosition += 7 // Aumenta vertical para a próxima linha
        })
      }

      doc.save('suporte.pdf')
      this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    },

    aumentarFonte() {
      this.baseFontSize++
    },
    diminuirFonte() {
      this.baseFontSize--
    },
  },
}
</script>

<style lang="scss">
#copilot {
  .icon-copilot {
    img {
      background: #f7f7f7;
      color: #00aeef;
      border-radius: 10px;
      text-align: center;
      width: 40px;
      padding: 10px;
      cursor: pointer;
    }
  }
}
#modal-copilot {
  .copilot-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    span {
      cursor: pointer;
      background: #f2f2f2;
      width: 35px;
      height: 35px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      &.deslike {
        transform: rotate(180deg);
      }
    }
  }
  .copilot-messages {
    .copilot-messages-item {
      display: flex;
      justify-content: flex-start;
      gap: 10px;
      .icon {
        img {
          width: 16px;
        }
      }
      .text {
        font-size: 14px !important;
        h4 {
          font-weight: 700;
          font-size: 16px;
          margin-top: 5px;
        }
      }
    }
  }
  .loading-copilot {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin: 0 5px;
      animation: loading 1.5s infinite ease-in-out;

      &:nth-child(1) {
        background-color: #000;
      }

      &:nth-child(2) {
        background-color: #000;
      }

      &:nth-child(3) {
        background-color: #000;
      }
    }
  }

  @keyframes loading {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
<style>
/* .typed-element h2,
h3 {
  font-size: 14px !important;
} */

.typed-element p {
  margin: 10px 0;
  text-align: justify;
}
</style>
